var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExportTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07163 15.1375V9.1375C7.07163 8.50783 7.29338 7.97125 7.73688 7.52775C8.18038 7.08425 8.71696 6.8625 9.34663 6.8625H16.8331L14.3956 4.425L16.0119 2.80875L21.2031 8L16.0059 13.1972L14.3956 11.6L16.8331 9.1375H9.34663V15.1375H7.07163ZM5.07163 21.2032C4.44596 21.2032 3.91038 20.9805 3.46488 20.535C3.01938 20.0895 2.79663 19.5539 2.79663 18.9282V4.07175H5.07163V18.9282H16.9281V15.1375H19.2031V18.9282C19.2031 19.5539 18.9804 20.0895 18.5349 20.535C18.0894 20.9805 17.5538 21.2032 16.9281 21.2032H5.07163Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportTo);
export default __webpack_public_path__ + "static/media/icon-export-to.da89dd34e2c2b0e4742b3dfbb85467de.svg";
export { ForwardRef as ReactComponent };